/**
 * RNR's Input, on the design file's Field spec: --popover for the control surface, --input for its
 * border, and a focus state that draws a 3px --accent ring rather than moving anything.
 */
import { cn } from '@/lib/utils';
import { Platform, TextInput } from 'react-native';

function Input({ className, ...props }: React.ComponentProps<typeof TextInput> & React.RefAttributes<TextInput>) {
  return (
    <TextInput
      className={cn(
        'border-input bg-popover text-foreground text-body h-10 w-full min-w-0 flex-row items-center rounded-sm border px-3 py-2',
        props.editable === false && cn('bg-muted text-muted-foreground', Platform.select({ web: 'cursor-not-allowed' })),
        Platform.select({
          web: cn(
            'placeholder:text-muted-foreground/70 selection:bg-accent outline-none transition-[color,box-shadow]',
            'focus-visible:border-ring focus-visible:ring-accent focus-visible:ring-[3px]',
            'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
          ),
          native: 'placeholder:text-muted-foreground/70',
        }),
        className,
      )}
      {...props}
    />
  );
}

export { Input };
